import { Link } from "react-router-dom";
import React from "react";
import "../styles/CloudPlatform.css";
import cloud1 from "../assets/services/cloud 1.jpeg";
import cloud2 from "../assets/services/CLOUD 2.jpeg";

const solutions = [
  {
    title: "Cloud Migration",
    description:
      "Move applications, data and business workloads to the cloud with a structured migration approach designed around your requirements.",
  },
  {
    title: "Cloud Infrastructure",
    description:
      "Build reliable and scalable cloud infrastructure that supports business applications, teams and growing digital operations.",
  },
  {
    title: "Cloud Applications",
    description:
      "Develop and manage cloud-based applications that provide flexibility, accessibility and better performance.",
  },
  {
    title: "Storage & Backup",
    description:
      "Protect important business data with reliable cloud storage, backup and recovery solutions.",
  },
  {
    title: "DevOps & Automation",
    description:
      "Improve development and deployment workflows through cloud automation, continuous integration and efficient processes.",
  },
  {
    title: "Cloud Support",
    description:
      "Get ongoing assistance for cloud environments, applications, infrastructure and everyday technical requirements.",
  },
];

const process = [
  {
    title: "Assess",
    description:
      "We understand your existing applications, infrastructure and business requirements before planning the right cloud approach.",
  },
  {
    title: "Migrate",
    description:
      "We move applications and workloads carefully while focusing on security, reliability and minimal disruption.",
  },
  {
    title: "Configure",
    description:
      "We organize cloud infrastructure, applications, storage and workflows according to your operational needs.",
  },
  {
    title: "Optimize",
    description:
      "We continuously improve cloud performance, reliability and resource usage as your business grows.",
  },
];

function CloudPlatforms() {
  return (
    <main className="cloud-page">

      {/* HERO */}
      <section className="cloud-hero">
        <div className="cloud-hero-content">
          <span className="cloud-eyebrow">
            CLOUD PLATFORMS
          </span>

          <h1>
            Build Beyond
            <span> Infrastructure</span>
          </h1>

          <p>
            Build flexible, scalable and reliable digital
            environments with cloud technologies designed
            around the way your business works.
          </p>

          <a href="#cloud-solutions" className="cloud-primary-btn">
            Explore Cloud Solutions
            <span>→</span>
          </a>
        </div>

        <div className="cloud-hero-visual">
          <div className="cloud-hero-image">
            <img
              src={cloud1}
              alt="Cloud computing technology"
            />
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="cloud-intro">
        <div className="cloud-intro-header">
          <div className="cloud-intro-label">
            <span>01</span>
            <p>WHAT WE PROVIDE</p>
          </div>

          <div className="cloud-intro-heading">
            <h2>
              Cloud technology that
              <span> grows with your business</span>
            </h2>

            <p>
              From cloud migration and infrastructure to
              applications, storage and automation, we help
              businesses build a reliable digital foundation
              for the future.
            </p>
          </div>
        </div>

        <div className="cloud-intro-content">
          <div className="cloud-intro-main">
            <span>OUR APPROACH</span>

            <h3>
              The cloud should make your business
              <strong> more flexible and efficient</strong>
            </h3>

            <p>
              We focus on practical cloud solutions that improve
              accessibility, scalability, reliability and
              operational efficiency without adding unnecessary
              complexity.
            </p>
          </div>

          <div className="cloud-intro-points">

            <div className="cloud-intro-point">
              <span>01</span>

              <div>
                <h4>Scalable infrastructure</h4>

                <p>
                  Build cloud environments that can adapt as
                  your applications, users and business needs grow.
                </p>
              </div>
            </div>

            <div className="cloud-intro-point">
              <span>02</span>

              <div>
                <h4>Reliable systems</h4>

                <p>
                  Create dependable environments with proper
                  storage, backup and infrastructure planning.
                </p>
              </div>
            </div>

            <div className="cloud-intro-point">
              <span>03</span>

              <div>
                <h4>Smarter operations</h4>

                <p>
                  Use automation and cloud-based workflows to
                  simplify everyday technical operations.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* SOLUTIONS */}
      <section className="cloud-solutions" id="cloud-solutions">

        <div className="cloud-section-heading">

          <div>
            <span className="cloud-small-label">
              CLOUD SERVICES
            </span>

            <h2>
              Explore our
              <span> cloud solutions</span>
            </h2>
          </div>

          <p>
            Practical cloud services designed to help businesses
            migrate, operate and grow with confidence.
          </p>

        </div>

        <div className="cloud-solutions-grid">

          {solutions.map((item) => (
            <article
              className="cloud-solution-card"
              key={item.title}
            >
              <div className="cloud-card-content">

                <h3>{item.title}</h3>

                <p>{item.description}</p>

              </div>
            </article>
          ))}

        </div>

      </section>

      {/* TECHNOLOGY SECTION */}
      <section className="cloud-tech-section">

        <div className="cloud-tech-content">

          <span className="cloud-small-label">
            CONNECTED CLOUD
          </span>

          <h2>
            From infrastructure
            <span> to innovation</span>
          </h2>

          <p>
            Cloud technology gives businesses the flexibility
            to build, launch and improve digital services without
            being limited by traditional infrastructure.
          </p>

          <div className="cloud-tech-points">

            <div>
              <strong>01</strong>

              <h4>Flexible infrastructure</h4>

              <p>
                Scale resources according to changing business
                requirements and application demand.
              </p>
            </div>

            <div>
              <strong>02</strong>

              <h4>Secure data</h4>

              <p>
                Organize storage and backup systems to protect
                important business information.
              </p>
            </div>

            <div>
              <strong>03</strong>

              <h4>Automated workflows</h4>

              <p>
                Improve deployment and operational processes
                with modern cloud automation.
              </p>
            </div>

          </div>

        </div>

        <div className="cloud-tech-visual">

          <div className="cloud-tech-image">

            <img
              src={cloud2}
              alt="Cloud infrastructure servers"
            />

          </div>

        </div>

      </section>

      {/* PROCESS */}
      <section className="cloud-process">

        <div className="cloud-process-heading">

          <span className="cloud-small-label">
            HOW WE WORK
          </span>

          <h2>
            A smarter path to
            <span> the cloud</span>
          </h2>

          <p>
            We follow a structured approach that keeps cloud
            implementation practical, reliable and aligned
            with your business goals.
          </p>

        </div>

        <div className="cloud-process-grid">

          {process.map((item, index) => (
            <article
              className="cloud-process-item"
              key={item.title}
            >

              <div className="cloud-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </article>
          ))}

        </div>

      </section>

      {/* FINAL CTA */}
      <section className="cloud-final">

        <div className="cloud-final-content">

          <div className="cloud-final-main">

            <div className="cloud-final-label">
              <span></span>
              BUILD IN THE CLOUD
            </div>

            <h2>
              Ready to move
              <span> beyond infrastructure?</span>
            </h2>

            <p>
              Tell us about your applications, infrastructure
              or cloud requirements. We can help you explore
              the right approach for your business.
            </p>

          </div>

          <div className="cloud-final-action">

            <div className="cloud-final-brand">
              <strong>TECHLYNX INNOVATIONS</strong>

              <p>
                Cloud · Technology · Growth
              </p>
            </div>

            <Link
              to="/contact"
              className="cloud-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>

          </div>

        </div>

      </section>

    </main>
  );
}

export default CloudPlatforms;